import React, { useState } from 'react';
import VouchersForm from './VouchersForm';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Vouchers, gAPI_Vouchers_By_Id } from '../../../../../../../constants/APIs';
import PropTypes from 'prop-types';
import BuyOptionForm from './BuyoptionForm';
export default function DeleteVoucherForm({ id, propertyId, optionId, handleDeleteForm, LoadData }) {
  const [isShow, setisShow] = useState(true);

  const handleSubmit = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Vouchers_By_Id}/${id}`,
    })
      .then((res) => {
        res.data.sellingOptions = res.data.sellingOptions.filter((m) => {
          if (m.id === optionId) {
            m.status = 'Archived';
          }
          return m;
        })
        AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_Vouchers}/${id}`,
          data: res.data,
        }).then(() => {
          LoadData();
          setisShow(!isShow);
          handleDeleteForm();
        });
      });
    handleDeleteForm();
  };
  return (
    <div>
      <Modal
        isOpen={isShow}
        toggle={() => { setisShow(!isShow); handleDeleteForm(); }}
        size="lg"
        style={{ maxWidth: '50%' }}
      >
        <ModalHeader toggle={() => { setisShow(!isShow); handleDeleteForm(); }}><h3>Delete Confirmation</h3></ModalHeader>
        <ModalBody><div className=""><h5>Are you sure you want to delete the voucher buy option ?</h5></div></ModalBody>
        <ModalFooter>
          <Button onClick={() => { setisShow(!isShow); handleDeleteForm(); }}>
            Cancel
          </Button>
          <Button color="primary" onClick={() => { handleSubmit() }}>
            Delete
          </Button>
        </ModalFooter>
      </Modal >
    </div >
  );
}

DeleteVoucherForm.propTypes = {
  id: PropTypes.string.isRequired,
};
